// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getFirestore } from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB8FcqzKY7eNqBO5UtIZcy9_XFXtu0HqlM",
  databaseURL: "https://developer-ayusudi-default-rtdb.firebaseio.com",
  projectId: "developer-ayusudi",
  authDomain: "developer-ayusudi.firebaseapp.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const db = getFirestore()